module.exports = __webpack_public_path__ + "static/media/skillenza.7b7a76ef.png";